export default "__VITE_ASSET__DLUiVfzW__"